module.exports = __webpack_public_path__ + "img/milica_kostic.5ab8b549.png";